import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Table } from 'reactstrap';

class CapitalTableRow extends Component {
    displayName = CapitalTableRow.name

    formatCurrency(value) {
        var v = Math.floor(value);
        return Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(v);
    }

    render() {
        return (
            <tr className='text-right'>
                <th className='text-left'>{this.props.title}</th>
                <td>{this.formatCurrency(this.props.value) }</td>
            </tr>
        );
    }
}

class CapitalTable extends Component {
    displayName = CapitalTable.name

    render() {
        var rows = [];
        for (var i = 0; i < this.props.growthCapitalByYear.length; i++) {
            rows.push(<CapitalTableRow key={this.props.growthCapitalByYear[i].year} title={this.props.growthCapitalByYear[i].year} value={this.props.growthCapitalByYear[i].value} />);
        }

        return (
            <React.Fragment>
                <h3>Capital growth</h3>
                <Table>
                    <tbody>
                        {rows}
                        <CapitalTableRow title="Total" value={this.props.growthCapitalTotal} />
                    </tbody>
                </Table>
            </React.Fragment>
        );
    }

}

const mapStateToProps = state => {
    return state.property;
};

export default connect(mapStateToProps)(CapitalTable)


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/CapitalTable.jsx